export enum ActionType {
    TRANSFER = "transfer_internal",
}
